module.exports = __webpack_public_path__ + "devices.34f57576.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/devices.svg
 ** module id = 987
 ** module chunks = 0
 **/